/* eslint-disable no-magic-numbers */
interface HttpResponse {
  status: number;
  statusText: string;
  responseJSON: any;
  responseURL: string;
}

interface TrandictionalResponse {
  success: boolean;
  code: number;
  message: string;
}
export default function handleErrorStatus(response: HttpResponse) {
  const result: TrandictionalResponse = {
    success: false,
    code: response.status,
    message: '',
  }
  switch (response.status) {
    case 400:
      // 如果服务器返回错误信息,就显示服务器的信息,否则显示请求错误(数据的字段名称或者是字段类型和后台的实体类不一致或者json字符串类型转化有误)
      result.message = '请求错误, 入参语法格式有误'
      break
    case 403:
      result.message = process.env.NODE_ENV === 'development'
        ? `当前用户无权限请求接口${response.responseURL}`
        : '无权限进行相关操作，请反馈给网站提供者'
      break
    case 404:
      result.message = process.env.NODE_ENV === 'development'
        ? `接口${response.responseURL}未找到`
        : '请确认链接是否正确'
      break
    case 500:
    case 504:
      result.message = process.env.NODE_ENV === 'development'
        ? '服务器发生内部错误，无法完成请求'
        : '请刷新页面后重试'
      break
    default:
      result.message = response.statusText ?? '未分类的错误'
  }

  // 如果返回的结构带有 message 信息，则带上自定义的 message 信息（兼容 error 和没有嵌套 error 的情况）
  if (response.responseJSON?.error?.message) {
    result.message = response.responseJSON.error.message
  } else if (response.responseJSON?.message) {
    result.message = response.responseJSON.message
  }
  return result
}
